<template>
  <header :class='$style.container'>
    <div :class='$style.nav'>
      <div :class='$style.logo'></div>
      <ul :class='$style.navUl'>
        <li>
          <a href='#price'>价格表</a>
        </li>
        <li>
          <a href='#gift'>蟹券/礼盒</a>
        </li>
        <li>
          <a href='#pay'>批发/团购</a>
        </li>
        <li>
          <a href='#video'>养殖基地</a>
        </li>
        <li>
          <a href='#about'>关于</a>
        </li>
        <li>
          <a href='#contact'>联系</a>
        </li>
      </ul>
    </div>
    <lazy-image :class='$style.text' :src='require("../assets/header-text.png")' />
    <div :class='$style.contact'>
      <div :class='[$style.contactItem,$style.title]'>商务合作</div>
      <a :class='[$style.contactItem,$style.itemFlex]' :href='`tel:${phone1}`'>
        <lazy-image :class='$style.iconPhone' :src='require("../assets/icon-phone.png")' />
        <div :class='$style.contactItemDetail'>
          <div>零售团购：</div>
          <div>{{phone1}}</div>
        </div>
      </a>
      <a :class='[$style.contactItem,$style.itemFlex]' :href='`tel:${phone2}`'>
        <lazy-image :class='$style.iconPhone' :src='require("../assets/icon-phone.png")' />
        <div :class='$style.contactItemDetail'>
          <div>批发：</div>
          <div>{{phone2}}</div>
        </div>
      </a>
    </div>
  </header>
</template>

<script>
export default {
  name: "LayoutHeader",
  data() {
    return {
      phone1: "",
      phone2: ""
    };
  },
  mounted() {
    let { phone1, phone2 } = phones;
    this.phone1 = phone1;
    this.phone2 = phone2;
  }
};
</script>

<style lang='scss' module>
@import "../tool";
@media screen and (max-width: 750px) {
  .title {
    display: none;
  }
  .contact {
    flex-direction: column;
    left: 0 !important;
    right: 0 !important;
    align-items: flex-start !important;
  }
  .contactItem ~ .contactItem {
    margin-top: 18px;
  }
  .container {
    padding: 0 !important;
  }
  .navUl {
    display: none;
  }
  .logo {
    margin-top: rem(24) !important;
    margin-left: rem(36) !important;
    width: rem(152) !important;
    height: rem(70) !important;
    background: url("../assets/logo-mobile.png") no-repeat center / contain !important;
  }
  .text {
    margin-top: rem(124) !important;
    margin-right: auto;
    margin-left: auto;
    width: rem(344);
  }
}
.container {
  position: relative;
  height: 728px;
  width: 100%;
  padding: 0 56px;
  background: url("../assets/bg-header.jpg") no-repeat center / cover;
}
.logo {
  width: 270px;
  height: 160px;
  background: url("../assets/logo.png") no-repeat center / contain;
}
.text {
  display: block;
  margin-top: 62px;
  width: 350px;
}
.nav {
  display: flex;
  align-items: center;
}
.navUl {
  flex: 1;
  @extend .flex;
  justify-content: flex-end;
  margin-right: 56px;
  padding: 0;
  font-size: 14px;
  color: #d8c39f;
  text-decoration: none;
  li {
    list-style: none;
    cursor: pointer;
    a {
      color: #d8c39f;
    }
  }
  li ~ li {
    margin-left: 36px;
  }
}
.contact {
  @extend .flex;
  position: absolute;
  left: 56px;
  right: 56px;
  bottom: -44px;
  padding: 18px 56px;

  background: #d8c39f;
  z-index: 2;
}
.contactItem {
  flex: 1;
}
.icon {
  width: 52px;
  height: 52px;
}
.iconPhone {
  @extend .icon;
}
.itemFlex {
  @extend .flex;
}
.contactItemDetail {
  margin-left: 16px;
}
</style>